export enum InterviewStatus {
  // stepType:stepStatus
  interviewPendingScheduleCount = '2:1', // 面试待约
  interviewPendingAcceptCount = '2:2', // 面试待接受
  interviewPendingCount = '2:3', // 面试待面
  interviewPendingAdjustmentCount = '2:5', // 面试待调整
  interviewExpiredCount = '2:6', // 面试已过期
  interviewResultPendingCount = '2:7', // 面接結果待ち（面试结果待确认）
  offerExtendedCount = '3:1', // 内定通知書送付待ち
  offerExtendedResultCount = '3:2', // 内定結果待ち
  onboardingPendingConfirmCount = '4:2', // 待确认入职
}
export const InterviewDelimiter = ':'

/**
 * 面试/选考状态（interviewStatus 字段取值）
 */
export enum InterviewStatusEnum {
  /** 未激活（初始状态） */
  INACTIVE = 0,
  /** 待约面/待筛选/内定通知书待发送 */
  PENDING_SCHEDULE = 1,
  /** 待接收/OFFER_RESULT_PENDING */
  PENDING_ACCEPT = 2,
  /** 待面试 */
  PENDING_INTERVIEW = 3,
  /** 已完成 */
  COMPLETED = 4,
  /** 待调整 */
  REJECTED = 5,
  /** 面试已过期 */
  EXPIRED = 6,
  /** 结果待确认（面试时间已确定且已过，等待录入面试结果） */
  RESULT_PENDING = 7,
}

export enum SelectionListTab {
  // 选考Tab
  ResumeScreening = 'first', // 简历筛选
  Interview = 'second', // 面试
  OfferExtended  = 'third', // 内定
  PendingOnboarding  = 'fouth', // 待入职
  Terminated = 'fifth', // 已终止
  Onboarded = 'sixth', // 已入职
}
export const SelectionStatusMap = {
  [SelectionListTab.ResumeScreening]: 1,   // 简历筛选
  [SelectionListTab.Interview]: 2,  // 面试
  [SelectionListTab.OfferExtended]: 3,   // 内定
  [SelectionListTab.PendingOnboarding]: 4,   // 待入职
  [SelectionListTab.Terminated]: 5,   // 已终止
  [SelectionListTab.Onboarded]: 6    // 已入职
}
export enum StepType  {
  ResumeScreening = 1, // 简历筛选
  Interview = 2, // 面试
  OfferExtended  = 3, // 内定
  Onboarded  = 4, // 入职
}
// 1 进行中，2 已终止， 3 结束
export enum ProgressStatus  {
  Doing = 1,   // 进行中
  Terminated = 2,  // 已终止
  End = 3,   // 结束
}

export enum ApplicationChannel {
  Agents = -1
}
export enum ResumeSources {
  SelfCandidates = -1
}